import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Styles from './DiagonalBackground.styles';

const Wrapper = styled.div`${Styles.wrapper}`; // prettier-ignore
const DiagaonalWrapper = styled.div`${Styles.diagonalWrapper}`; // prettier-ignore
const Triangle = styled.div`${Styles.triangle}`; // prettier-ignore

/**
 * DiagonalBackground component
 * @returns {JSX}
 */
const DiagonalBackground = ({ height, backgroundColor }) => {
  return (
    <Wrapper>
      <DiagaonalWrapper height={height} backgroundColor={backgroundColor} />
      <Triangle backgroundColor={backgroundColor} height={height} />
    </Wrapper>
  );
};

DiagonalBackground.propTypes = {
  height: PropTypes.number,
  backgroundColor: PropTypes.string
};

export default DiagonalBackground;
